import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const alias: RouteRecordItem = {
  path: '/alias',
  name: 'Alias',
  component: LAYOUT,
  redirect: { name: 'AliasDetail' },
  meta: {
    orderNo: 10,
    icon: 'oui:token-alias',
    title: t('routes.alias.别名管理'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'AliasDetail',
      component: () => import('@/pages/alias/index.vue'),
      meta: {
        title: t('routes.alias.别名管理'),
      },
    },
  ],
}

export default alias
